<script>
export default {
  props: {

  },

}
</script>

<template>
  <div
    class="booking-container"
  >
    <slot/>
  </div>
</template>
